import { render, staticRenderFns } from "./edit-tenant.vue?vue&type=template&id=51b2db81&scoped=true"
import script from "./edit-tenant.vue?vue&type=script&lang=js"
export * from "./edit-tenant.vue?vue&type=script&lang=js"
import style0 from "./edit-tenant.vue?vue&type=style&index=0&id=51b2db81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b2db81",
  null
  
)

export default component.exports